import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare let swal:any;
import { CommonService } from '../common.service';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  loginresponse:any;
 userrole:any;
  constructor(private router: Router,public commonService: CommonService) { }

  ngOnInit(): void {
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole=this.loginresponse.user_role;
  }

}
